module.exports = __webpack_public_path__ + "img/certificateZoom.6aef8f76.png";